// Access tab under SiteLayout — HA publication + NetBird overlay intent.
// SiteLayout owns the PageHeader/tabs, so this composes section headings only.
// Endpoints are site_slug-scoped; accountSlug is accepted for symmetry with
// the other site panels but unused here.

import { useIsPlatformAdmin } from "../auth/useIsPlatformAdmin";
import { PublicationEditor } from "./PublicationEditor";
import { NetbirdEditor } from "./NetbirdEditor";

export function SiteAccessPanel({
  accountSlug: _accountSlug,
  siteSlug,
}: {
  accountSlug: string;
  siteSlug: string;
}) {
  const canWrite = useIsPlatformAdmin();
  return (
    <div style={{ display: "grid", gap: 28 }}>
      <section>
        <h3 style={{ margin: "0 0 12px", fontSize: "0.95rem" }}>Publication</h3>
        <PublicationEditor siteSlug={siteSlug} canWrite={canWrite} />
      </section>
      <section>
        <h3 style={{ margin: "0 0 12px", fontSize: "0.95rem" }}>NetBird overlay</h3>
        <NetbirdEditor siteSlug={siteSlug} canWrite={canWrite} />
      </section>
    </div>
  );
}
